<template>
  <div class="app-belated-porting" :class="['step-' + this.getCurrentStep]">
    <div class="main-content">
      <div class="container">
        <StepsBar :current-step="getCurrentStep" :steps="belatedPortingSteps" @onStepClick="changeStep">
          <template v-for="slot in possibleChildSlotsFor('CheckoutSteps')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </StepsBar>
        <Selection process="belatedPorting" :ref="getCurrentStep" @goForward="goToNextStep" v-if="getCurrentStep === 'mnpData'" @updatedMnpActive="updateCart()" @updatedProvider="updateCart(false)">
          <template v-for="mnpSlot in possibleChildSlotsFor('MnpData')" v-slot:[`${mnpSlot.child}`]>
            <slot :name="`${mnpSlot.parent}`"></slot>
          </template>
          <template v-for="simSlot in possibleChildSlotsFor('SimData')" v-slot:[`${simSlot.parent}`]>
            <slot :name="`${simSlot.parent}`"></slot>
          </template>
          <template v-for="holderSlot in possibleChildSlotsFor('Holder')" v-slot:[`${holderSlot.parent}`]>
            <slot :name="`${holderSlot.parent}`"></slot>
          </template>
        </Selection>
        <Summary
          @goBack="goToPreviousStep"
          @goForward="goToNextStep"
          @onStepClick="changeStep"
          v-if="getCurrentStep === 'summary'"
          :targetTariff="targetTariff"
          :promoBenefits="promoBenefits"
          :prevPromotions="prevPromotions"
          :newTariffSelected="newTariffSelected">
          <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="cartSlot in possibleChildSlotsFor('Cart')" v-slot:[`${cartSlot.parent}`]>
            <slot :name="`${cartSlot.parent}`"></slot>
          </template>
        </Summary>
        <StickyCart
                     v-if="getCurrentStep !== 'summary'"
                    :fee="newTariffSelected ? promoBenefits.promoPrice.promoAmount : bookedPrice">
          <template v-for="slot in possibleChildSlotsFor('Cart')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </StickyCart>
      </div>
    </div>
    <div id="cart-sidebar" class="sidebar">
      <div class="container">
        <Cart process="belatedPorting"
              :targetTariff="targetTariff"
              :promoBenefits="promoBenefits"
              :prevPromotions="prevPromotions"
              :newTariffSelected="newTariffSelected"
              class="card">
          <template v-for="slot in possibleChildSlotsFor('Cart')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </Cart>
      </div>
      <Stepper
        class="mobile-stepper"
        :loading-next="loading"
        :disabledNext="disableNextButton"
        :show-prev=true
        @prev=goToPreviousStep
        @next="next()"
        :aria-label-prev="getSlotText('accessibilitySelfservicePrevBtnAltStepperMnpData')"
        :aria-label-next="getSlotText('accessibilitySelfserviceNextBtnAltStepperMnpData')"
      >
        <template v-for="slot in possibleChildSlotsFor(mobileStepperSlots)" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Stepper>
    </div>
  </div>
</template>

<script>
import StepsBar from '@/components/checkout/StepsBar.vue'
import StickyCart from '@/components/checkout/belatedPorting/StickyCart.vue'
import Cart from '@/components/checkout/belatedPorting/Cart.vue'
import Selection from '@/components/checkout/belatedPorting/Selection.vue'
import Summary from '@/components/checkout/belatedPorting/summary/Summary.vue'
import { checkoutTracking } from '@/helper/checkoutTracking'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import trackingHandler from '@/mixins/trackingHandler'
import Stepper from '@/components/generic/Stepper.vue'
import transaction from '@/mixins/transaction'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import { splitError } from '@/helper/splitError'
import queryBookedTariffsAndTariffoptions from '@/store/modules/checkoutv2/cart/gql/queryBookedTariffsAndTariffoptions'
import date from '@/mixins/validators/date'

export default {
  name: 'BelatedPorting',
  components: { Selection, Summary, StepsBar, Cart, StickyCart, Stepper },
  props: {
  },
  data () {
    return {
      belatedPortingSteps: ['mnpData', 'summary'],
      loading: false,
      disableNextButton: false,
      tariffs: null,
      tariffoptions: null
    }
  },
  async mounted () {
    this.updateCart()
  },
  mixins: [
    trackingHandler,
    transaction('belatedPorting'),
    date
  ],
  methods: {
    ...mapMutations('checkoutv2/belatedPorting', ['setStep']),
    ...mapMutations('checkoutv2/belatedPorting/_cart', ['setBookedTariff', 'setSelectedTariffoptionIds', 'setBookedAboOption', 'setBookedVolume', 'setBookedPrice']),
    ...mapActions('checkoutv2/belatedPorting/_cart', ['queryCart']),
    changeStep (step) {
      this.setStep(step)
      this.triggerPageviewTracking(this.belatedPortingSteps.indexOf(step))
      window.scrollTo(0, 0)
      this.$nextTick(() => {
        this.focusStep()
      })
    },
    updateCart (triggerPageview = true) {
      this.startLoader()

      this.queryCart({})
        .then((res) => {
          if (triggerPageview) {
            this.triggerPageviewTracking()
          }
        })
        .catch((error) => {
          this.errorToast(this.getErrorMessage(error))
          this.triggerErrorTracking(error)
        })
        .finally(() => {
          this.stopLoader()
        })
    },
    goToPreviousStep () {
      if (this.getCurrentStep === 'mnpData') {
        window.location.href = this.getSlotText('linkBackButtonHolder')
      } else {
        const newIndex = Math.max(0, (this.belatedPortingSteps.indexOf(this.getCurrentStep) - 1))
        this.step(newIndex)
        this.$nextTick(() => {
          this.focusStep()
        })
      }
    },
    goToNextStep () {
      const newIndex = Math.min((this.belatedPortingSteps.length - 1), (this.belatedPortingSteps.indexOf(this.getCurrentStep) + 1))
      this.step(newIndex)
      this.$nextTick(() => {
        this.focusStep()
      })
    },
    step (newIndex) {
      this.setStep(this.belatedPortingSteps[newIndex])
      this.triggerPageviewTracking(newIndex)
      window.scrollTo(0, 0)
    },
    focusStep () {
      const spanElement = document.querySelector('.' + this.getCurrentStep + ' .label')
      spanElement.focus()
    },
    next () {
      this.$refs[this.getCurrentStep].save()
    },
    triggerPageviewTracking (stepIndex = this.belatedPortingSteps.indexOf(this.getCurrentStep)) {
      checkoutTracking('belatedPorting', this.$store, this.belatedPortingSteps[stepIndex], stepIndex + 1)
    },
    handleDisableUpdate (value) {
      this.disableNextButton = value
    }
  },
  computed: {
    ...mapGetters('checkoutv2/belatedPorting/_cart', ['targetTariff', 'promoBenefits', 'bookedPrice']),
    ...mapGetters('checkoutv2/belatedPorting/_mnpData', { mnpActive: 'active', mnpProvider: 'provider' }),
    ...mapGetters('promotion/activePromotions', {
      prevPromotions: 'activePromotions'
    }),
    newTariffSelected: function () {
      return this.mnpProvider?.key !== null && this.mnpProvider?.key !== ''
    },
    getCurrentStep: function () {
      return this.$store.getters['checkoutv2/belatedPorting/step']
    },
    mobileStepperSlots: function () {
      if (this.getCurrentStep === 'mnpData' && this.mnpActive === true) {
        return 'MnpStepper' + this.getCurrentStep.charAt(0).toUpperCase() + this.getCurrentStep.slice(1)
      } else {
        return 'Stepper' + this.getCurrentStep.charAt(0).toUpperCase() + this.getCurrentStep.slice(1)
      }
    }
  },
  apollo: {
    tariffs: function () {
      return wrapQuery(queryBookedTariffsAndTariffoptions, this, ['tariffs', 'tariffoptions'], {}, () => {
        this.setBookedTariff(this.tariffs.bookedTariff)
        const aboOptions = this.tariffoptions?.bookedTariffoptions?.bookedTariffoptions.filter(opt =>
          opt.automaticExtension && ['CDL', 'CAN', 'TER'].includes(opt.statusKey)
        ) || []
        const aboOption = aboOptions[0] || null
        this.setBookedAboOption(aboOption)
        this.setSelectedTariffoptionIds(aboOption?.tariffoptionId ? [aboOption.tariffoptionId] : [])
        // set volume
        let volumeAmount = this.tariffs.bookedTariff?.volumes[0]?.amount || 0
        volumeAmount += aboOptions.length > 0 ? aboOptions[0].volumes[0]?.amount : 0
        this.prevPromotions?.forEach(promo => {
          if (!promo.duration && this.isPermanentDate(promo.expirationDate)) {
            promo.incentives?.forEach(incentive => {
              if (incentive.type === 'volume') {
                volumeAmount += incentive.amount
              }
            })
          }
        })
        this.setBookedVolume(volumeAmount)
        // set price
        let priceAmount = this.tariffs.bookedTariff?.basicFee || 0
        priceAmount += aboOptions.length > 0 ? aboOptions[0].price : 0
        this.prevPromotions?.forEach(promo => {
          if (!promo.duration && this.isPermanentDate(promo.expirationDate)) {
            promo.incentives?.forEach(incentive => {
              if (incentive.type === 'credit') {
                priceAmount -= incentive.amount
              }
            })
          }
        })
        this.setBookedPrice(priceAmount)
      },
      {},
      (error) => {
        splitError(error).forEach(e => {
          this.errorMsg = e.message
        })
        if (!this.showError) {
          const data = {
            type: 'technical',
            message: this.errorMsg
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        }
        this.showError = true
      }
      )
    }
  }
}
</script>
